<div class="filter-container">
  <app-button [button]="showFiltersButton">
  </app-button>
</div>

<app-coupon-list [items]="coupons"></app-coupon-list>

<!--Filters-->
<app-filter [items]="filterItems"
            [showClearAll]="false">
</app-filter>